import { render } from "./InstallWizardAlarmActivationCard.vue?vue&type=template&id=c0040f5e"
import script from "./InstallWizardAlarmActivationCard.vue?vue&type=script&lang=js"
export * from "./InstallWizardAlarmActivationCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__